module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "IMG"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vi",
      "title": "vi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "705",
      "src": "images/interior-house-002_fmt.jpg",
      "width": "500"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "SP-BRK",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_1",
      "title": "1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Billhead-1900"
  }, [_vm._v("PART 1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Barbaro-SC"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "Barbaro-CAPS"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "Barbaro-SC"
  }, [_vm._v("OME")]), _vm._v(" "), _c('span', {
    staticClass: "Barbaro-SC"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "Barbaro-CAPS"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "Barbaro-SC"
  }, [_vm._v("OST")]), _vm._v(" "), _c('span', {
    staticClass: "Barbaro-CAPS"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "Barbaro-SC"
  }, [_vm._v("AUSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline-Chapter-dl"
  }, [_c('span', {
    staticClass: "Billhead-1900"
  }, [_vm._v("OCTOBER 1855")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ae99aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 69
// module chunks = 0